import React, { Component } from "react";
import styled from "styled-components";
// import Icon from "@alboompro/boom-components/general/icon";
import Collapse from "./Collapse";
import RangeInput from "./RangeInput";

const Tooltip = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  background-color: #595959;
  border-radius: 3px;
  text-align: center;
  padding: 4px 20px;
  min-width: 120px;
  max-width: 180px;
  color: #ffffff;
  font-size: 11px;
  letter-spacing: 0.4px;
  font-weight: 400;
  opacity: 0;
  pointer-events: none;
  z-index: 4;
  white-space: nowrap;
`;

const InputItem = styled.input`
  border: 1px solid transparent;
  border-radius: 3px;
  background-color: transparent;
  width: 35px;
  text-align: right;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:hover {
    outline: none;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
  }
  &:focus {
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
    outline: none;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
  }

  ${(props) => props.inputError && "border-color: #E83535;"}
`;

const RefContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SuffixRef = styled.span`
  display: block;
  margin-left: 2px;
  font-size: 14px;
  color: #212121;
`;

const SuffixTypeButton = styled.button`
  background: transparent;
  border: 0;
  color: ${(props) => (props.isActive ? "#252525" : "#bbbbbb")};
  cursor: ${(props) => (props.isActive ? "" : "pointer")};
`;

const WrapperInline = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-left: -8px;
  margin-right: -8px;
  padding: 10px;
  border-radius: 3px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f1f1f1;

    ${Tooltip} {
      opacity: 1;
      transition: 0.2s opacity 0.3s cubic-bezier(0.55, 0.3, 0.5, 0.9);
    }
  }

  ${RefContainer} {
    margin-left: 2px;

    input {
      font-size: 14px;
      border-radius: 3px;
      &:focus {
        box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
      }
      &:hover{
        border: 1px solid #ebebeb;
      }
    }
  }
`;

const WrapperIcon = styled.div`
  margin-right: 10px;

  > img {
    width: 18px;
  }
`;

class RangeSlide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      min: 0,
      max: 1,
      step: 1,
      suffix: "",
      inputValue: 0,
      options: [],
    };
  }

  componentDidMount() {
    this.setDefaultProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setDefaultProps(nextProps);
  }

  setDefaultProps = (receivedProps) => {
    const { currentType, options, currentValue } = receivedProps;
    let filterOptions;
    if (currentType) {
      filterOptions = options.filter((item) => item.type === currentType);
    } else {
      filterOptions = options;
    }

    const { min, max, step, type } = filterOptions[0];

    this.setState({
      min,
      max,
      step,
      suffix: type,
      inputValue: currentValue,
      options,
    });
  };

  handleUpdate = (value) => {
    const { updaterFn, name } = this.props;
    const { suffix } = this.state;

    updaterFn([
      { prop: name, value },
      { prop: `${name}Type`, value: suffix },
    ]);
  };

  inputBlur = (e) => {
    const { max } = this.state;
    const inputValue = e.target.value;

    const value = Number(inputValue) >= max ? max : inputValue;

    this.setState({ inputValue: value });
    this.handleUpdate(value);
  };

  inputChangeHandler = (e) => {
    const { max } = this.state;
    const inputValue = e.target.value;

    const value = Number(inputValue) >= max ? max : inputValue;
    this.setState({ inputValue });
    this.handleUpdate(value);
  };

  rangeInputChangeHandler = (e) => {
    this.setState({ inputValue: e.target.value });
    this.handleUpdate(e.target.value);
  };

  changeSuffix = (suffixType) => {
    const { options } = this.props;
    // const { suffix } = this.state;

    if (options.length > 1) {
      const suffixOptions = options.filter((item) => item.type === suffixType);
      const { defaultValue, min, max, step } = suffixOptions[0];

      this.setState(
        {
          min,
          max,
          step,
          suffix: suffixType,
          inputValue: defaultValue,
          options,
        },
        () => this.handleUpdate(defaultValue)
      );
    }
  };

  inputRefHandler = () => {
    const { min, max, suffix, step, inputValue, options } = this.state;

    return (
      <RefContainer>
        <InputItem
          type="number"
          onChange={this.inputChangeHandler}
          onBlur={this.inputBlur}
          min={min}
          max={max}
          step={step}
          value={inputValue}
          style={{ fontSize: 13 }}
        />
        <>
          {suffix && (
            <SuffixRef>
              {options.map((option) => (
                <SuffixTypeButton
                  key={option.type}
                  type="button"
                  onClick={() => this.changeSuffix(option.type)}
                  isActive={suffix === option.type}
                  style={{ fontSize: 13 }}
                >
                  {option.type}
                </SuffixTypeButton>
              ))}
            </SuffixRef>
          )}
        </>
      </RefContainer>
    );
  };

  renderInlineKind() {
    const { currentValue, label, icon, locale } = this.props;
    const { min, max, step } = this.state;

    return (
      <WrapperInline>
        <WrapperIcon>
          <img src={icon} alt="Icone" />
        </WrapperIcon>
        <RangeInput
          min={min}
          max={max}
          step={step}
          value={currentValue}
          onChange={this.rangeInputChangeHandler}
        />
        {this.inputRefHandler()}
        <Tooltip>{label[locale]}</Tooltip>
      </WrapperInline>
    );
  }

  render() {
    const { label, currentValue, options, icon, locale, tooltip } = this.props;
    const { min, max, step } = this.state;

    if (icon && options.length <= 1) {
      return this.renderInlineKind();
    }
    return (
      <Collapse
        label={label}
        locale={locale}
        tooltip={tooltip}
        propRef={this.inputRefHandler()}
        visible
      >
        <RangeInput
          min={min}
          max={max}
          step={step}
          value={currentValue}
          onChange={this.rangeInputChangeHandler}
        />
      </Collapse>
    );
  }
}

export default RangeSlide;
